export const UI_CONSTANTS = {
    MULTI: "MULTI",
    SAINSBURYS_SKU: "sainsburys-sku",
    SAINSBURYS_PACK: "sainsburys-pack",
    ARGOS: "argos-sku",
    LDMUI: "ldmui",
    LEGACYCONTAINER: "Legacy Container",
    LINKEDCONTAINER: "Linked Container",
    CASEWIIGHTSANDDIMS: "Case Weights & Dims",
    BREAKWIIGHTSANDDIMS: "Break Pack Weights & Dims",
    DASHBOARD: "Dashboard",
    PRODUCT_PATH:"/product"
}

export const LOCAL_STORAGE_CONSTANTS = {
    BEFORE_REF_OBJ: "beforeRefreshObject",
    IS_RELOAD: "isReload"
}

export const AUTH_CONSTANTS = {
    LDM_ADMIN: "ldm_admin",
    LDM_SERVICE: "ldm_service",
    LDM_USER: "ldm_user",
    LDM_ROLES_URL: "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
}